import { Alert, Box, Snackbar, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react'
import Mitra from '../components/bergabung/Mitra';
import Term from '../components/bergabung/Term';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: string;
}

export default function BergabungPage() {
  const [currentTab, setCurrentTab] = useState<string>("mitra")
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
  }>({
    open: false,
    message: "",
    severity: "success",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== currentTab}
        id={`simple-tabpanel-${value}`}
        aria-labelledby={`simple-tab-${value}`}
        {...other}
        className='w-fit bg-white rounded-md'
      >
        {value === currentTab && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className='w-full'>
        <div className="mb-8">
          <h1 className="font-bold text-3xl mb-2">Pengaturan Halaman Bergabung Dengan Kami</h1>
          <p className="text-sm text-neutral-600">
            Pengaturan Bergabung Dengan Kami
          </p>
        </div>

        <Tabs value={currentTab} onChange={(e, value) => { setCurrentTab(value) }} className='w-full'>
          <Tab label="Mitra dan Kolaborator" value={"mitra"} />
          <Tab label="Syarat dan Ketentuan" value={"term"} />
        </Tabs>

        <CustomTabPanel value={'mitra'} index={0}>
          <p className='font-bold'>Pengaturan Halaman Mitra dan Kolaborator</p>
          <Mitra />
        </CustomTabPanel>
        <CustomTabPanel value='term' index={1}>
          <p className='font-bold'>Pengaturan Halaman Syarat dan Ketentuan</p>
          <Term />
        </CustomTabPanel>
      </div>
    </>
  )
}

